<template>
<div>
    <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert_success" v-if="alert_show_edit === true">แก้ไขการติดต่อ
            เรียบร้อย</v-alert>
    </v-slide-x-reverse-transition>
    <div v-if="loading_page === true">
        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
            <v-skeleton-loader type="article, actions"></v-skeleton-loader>
        </v-sheet>
    </div>
    <div v-if="loading_page === false">
        <v-card>
            <div class="pa-3">
                <div class="mb-3">
                    <h2>การติดต่อ</h2>
                </div>
                <v-form>
                    <v-row>
                        <v-col cols="6">
                            <v-text-field label="ชื่อบริษัท" v-model="content.company_name_th" hide-details="auto" outlined></v-text-field>
                        </v-col>
                        <v-col cols="6">
                            <v-text-field label="ชื่อภาษาอังกฤษ" v-model="content.company_name_en" hide-details="auto" outlined></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-textarea outlined label="ที่อยู่" v-model="content.address"></v-textarea>
                        </v-col>
                         <v-col cols="12">
                            <v-text-field label="เวลาทำการ" v-model="content.office_hours" hide-details="auto" outlined></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field label="Google Map" v-model="content.google_map" hide-details="auto" outlined></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field label="เบอร์โทรติดต่อ" v-model="content.tel" type="tel" maxlength="11" @keypress="isNumber($event)" onpaste="return false" hide-details="auto" outlined></v-text-field>
                        </v-col>
                        <v-col cols="6">
                            <v-text-field label="Facebook Page (ชื่อเพจ)" v-model="content.facebook_name" hide-details="auto" outlined></v-text-field>
                        </v-col>
                        <v-col cols="6">
                            <v-text-field label="Facebook Page (Link)" v-model="content.facebook_link" hide-details="auto" outlined></v-text-field>
                        </v-col>
                        <v-col cols="6">
                            <v-text-field label="Instagram (ชื่อ)" v-model="content.instagram_name" hide-details="auto" outlined></v-text-field>
                        </v-col>
                        <v-col cols="6">
                            <v-text-field label="Instagram (Link)" v-model="content.instagram_link" hide-details="auto" outlined></v-text-field>
                        </v-col>
                        <v-col cols="6">
                            <v-text-field label="Shopee (ชื่อร้าน)" v-model="content.shopee_name" hide-details="auto" outlined></v-text-field>
                        </v-col>
                        <v-col cols="6">
                            <v-text-field label="Shopee (Link)" v-model="content.shopee_link" hide-details="auto" outlined></v-text-field>
                        </v-col>
                        <v-col cols="6">
                            <v-text-field label="Line Official Account (ชื่อร้าน)" v-model="content.line_name" hide-details="auto" outlined></v-text-field>
                        </v-col>
                        <v-col cols="6">
                            <v-text-field label="Line Official Account (Link)" v-model="content.line_link" hide-details="auto" outlined></v-text-field>
                        </v-col>
                        <v-col cols="4"></v-col>
                        <v-col cols="4">
                            <v-btn color="#28ab28" class="title_font_content_contact white--text" type="button" @click="editContact()" width="100%" height="50">
                                บันทึก
                            </v-btn>
                        </v-col>
                        <v-col cols="4"></v-col>
                    </v-row>
                </v-form>
            </div>
        </v-card>

    </div>
</div>
</template>

<script>
import contentcontact from '@/api/content/contentsetting/contentcontact.js'
export default {
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    data() {
        return {
            loading_page: true,
            alert_show_edit: false,
            content: {
                id: null,
                company_name_th: null,
                company_name_en: null,
                address: null,
                office_hours:null,
                google_map: null,
                tel: null,
                facebook_name: null,
                facebook_link: null,
                instagram_name: null,
                instagram_link: null,
                shopee_name: null,
                shopee_link: null,
                line_name: null,
                line_link: null,
            }
        }
    },
    methods: {
        async contentContactList() {
            this.loading_page = true
            this.content = {
                id: null,
                company_name_th: null,
                company_name_en: null,
                address: null,
                office_hours:null,
                google_map: null,
                tel: null,
                facebook_name: null,
                facebook_link: null,
                instagram_name: null,
                instagram_link: null,
                shopee_name: null,
                shopee_link: null,
                line_name: null,
                line_link: null,
            }
            contentcontact.contactList().then((response) => {
                if (response.data.successful === true) {
                    this.content = response.data.contact
                    this.loading_page = false
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        },
        async isNumber(evt) {
            evt = (evt) ? evt : window.event;
            let charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 45) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        async editContact() {
            const data = {
                company_name_th: this.content.company_name_th,
                company_name_en: this.content.company_name_en,
                address: this.content.address,
                office_hours:this.content.office_hours,
                map: this.content.google_map,
                tel: this.content.tel,
                facebook_name: this.content.facebook_name,
                facebook_link: this.content.facebook_link,
                instagram_name: this.content.instagram_name,
                instagram_link: this.content.instagram_link,
                shopee_name: this.content.shopee_name,
                shopee_link: this.content.shopee_link,
                line_name: this.content.line_name,
                line_link: this.content.line_link,
            }
            contentcontact.editContact(this.content.id, data).then((response) => {
                if (response.data.successful === true) {
                    this.contentContactList()
                    this.alert_show_edit = true
                    setTimeout(() => this.alert_show_edit = false, 5000)
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })

        }
    },
    mounted() {
        this.contentContactList()
    }
}
</script>

<style scoped>
.title_font_content_contact {
    font-size: 22px !important;
}
</style>
